module.exports = __webpack_public_path__ + "static/media/ADAM JUNAID.f157a3ee.png";